import {Component} from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";
import {IRecalculateGameEntry} from "../../../interfaces/IRecalculateGameEntry";
import {MatList, MatListItem} from "@angular/material/list";

@Component({
  selector: 'app-entity-changes',
  standalone: true,
  templateUrl: './entity-changes.component.html',
  imports: [
    MatList,
    MatListItem
  ],
  styleUrls: ['./entity-changes.component.css']
})
export class EntityChangesComponent implements ICellRendererAngularComp {

  public recalculateEntry!: IRecalculateGameEntry;

  constructor() {
  }

  agInit(params: ICellRendererParams): void {
    this.recalculateEntry = params.data;
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }
}
